import {useCallback, useEffect, useRef} from 'react';

export function useHandlerDelay<T extends (...args: Parameters<T>) => void>(
  callback: T,
  active: boolean,
  delayMs: number,
) {
  const isHandlerAllowedRef = useRef(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!active) {
      isHandlerAllowedRef.current = false;
    } else {
      timeoutRef.current = setTimeout(() => {
        isHandlerAllowedRef.current = true;
        clearTimeout(timeoutRef.current);
      }, delayMs);
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [active, delayMs]);

  const handler = useCallback(
    (...args: Parameters<T>) => {
      if (isHandlerAllowedRef.current) {
        isHandlerAllowedRef.current = false;
        callback(...args);
      }
    },
    [callback],
  );

  return handler;
}
